<template>
  <path
    d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM18 19.0002H6C5.45 19.0002 5 18.5502 5 18.0002V6.00018C5 5.45018 5.45 5.00018 6 5.00018H18C18.55 5.00018 19 5.45018 19 6.00018V18.0002C19 18.5502 18.55 19.0002 18 19.0002Z"
  />
</template>
